import React, { useState, useEffect } from "react";
import "../../components/AddProfile/AddProfile.css";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const AddProfile = ({
  tokenStorage,
  openAddProfile,
  setOpenAddProfile,
  successMessage,
  setSuccessMessage,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [departmentDetailResponse, setDepartmentResponse] = useState([]);
  const [designationDetailResponse, setDesignationResponse] = useState([]);
  const [regionDetailResponse, setRegionDetailResponse] = useState([]);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [allocated, setAllocated] = useState([]); // Holds the API response
  const [allotedassets, setAllotedassets] = useState([]); // Selected assets

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    status: "",
    gender: "",
    email: "",
    phoneNo: "",
    department: "",
    designation: "",
    region: "",
    alloted_region: "",
    createdBy: "Vishal",
    is_active: "true",
    dept_id: "",
    desg_id: "",
    personal_email: "",
    personal_contact_no: "",
    emp_code: "",
    ProfilePic: "",
    is_master: false,
    is_sales: false,
    is_account: false,
    is_operation: false,
    is_HR: false,
    Date_Of_Joining: "",
    Date_Of_Leaving: "",
    Meal_Preference: false,
    Alloted_Asset: [],
    Location: "",
    Meal_Preference:""
  });

  const handleMultiSelectChange = (e) => {
    const { options } = e.target;
    const selectedValues = Array.from(options)
      .filter((option) => option.selected)
      .map((option) => option.value);

    setFormData({
      ...formData,
      Alloted_Asset: selectedValues, // Update the array with selected options
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "ProfilePic") {
      const file = files[0];

      if (file) {
        const allowedTypes = [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/webp",
        ];
        if (!allowedTypes.includes(file.type)) {
          alert("Only JPG, PNG, GIF, and WEBP files are allowed.");
          return;
        }
        getUpdatedImage(file, name);
      }
    } else {
      if (name === "email") {
        const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        setIsEmailValid(isValid);
      }

      if (name === "phoneNo") {
        // Ensure that the phone number contains only numeric values
        const isNumeric = /^\d+$/.test(value);
        if (!isNumeric && value !== "") {
          alert("Please enter a valid numeric phone number.");
          return;
        }
      }

      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const requiredFields = [
      "firstName",
      "lastName",
      "status",
      "gender",
      "email",
      "phoneNo",
      "dept_id",
      "desg_id",
      "region",
    ];
    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        alert(`Please fill out the ${field.replace(/_/g, " ")} field.`);
        return false;
      }
    }
    return true;
  };

  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setFormData({
          ...formData,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  const handleCheckedChange = (event) => {
    const { name, checked } = event.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!isEmailValid) {
      console.error("Invalid email address");
      return;
    }
  
    if (!validateForm()) {
      return;
    }
  
    // Prepare data
    const dataToSubmit = {
      ...formData,
      Alloted_Asset: formData.Alloted_Asset.join(","),
      Date_Of_Joining: formData.Date_Of_Joining || null, // Set to null if empty
      Date_Of_Leaving: formData.Date_Of_Leaving || null, // Set to null if empty
    };
  
    console.log("Submitting payload:", dataToSubmit); // Debugging payload
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminpost/AddEmployee`,
        dataToSubmit,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
  
      console.log("Data successfully posted:", response.data);
      setSuccessMessage("Data successfully submitted");
  
      setFormData({
        firstName: "",
        lastName: "",
        status: "",
        gender: "",
        email: "",
        phoneNo: "",
        department: "",
        designation: "",
        region: "",
        alloted_region: "",
        createdBy: "",
        is_active: "",
        personal_email: "",
        personal_contact_no: "",
        emp_code: "",
        is_master: false,
        is_sales: false,
        is_account: false,
        is_operation: false,
        is_HR: false,
        Date_Of_Joining: "",
        Date_Of_Leaving: "",
        Meal_Preference: false,
        Alloted_Asset: [],
        Location: "",
        Meal_Preference: "",
      });
  
      tokenStorage();
      setOpenAddProfile(!openAddProfile);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };
  



  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllAssets?Tseed=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          // Map the response data to the desired structure for the Multiselect
          const options = response.data.data.map((item) => ({
            id: item.Tseed, // Use a unique identifier
            name: item.description, // Display the description in the dropdown
          }));
          setAllocated(options); // Set options for the Multiselect
          console.log("allocated", options);
        })
        .catch((error) => {
          console.error("Error fetching asset details:", error);
        });
    }
  }, []);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}Adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setRegionDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETDepartment?department=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setDepartmentResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const handleSelectChange = (event) => {
    formData.dept_id = event.target.value;
    updateDesignation(event.target.value);
  };

  const updateDesignation = (dept) => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDesignation?designation=0&department=` + dept,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setDesignationResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  const handleSelectChangeDesignation = (event) => {
    formData.desg_id = event.target.value;
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="employeeDetail">
        {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )}
        <form className="employee-form" onSubmit={handleSubmit}>
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>First Name*</td>
              <td>Last Name*</td>
              <td>Status</td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                  className="input-employee"
                />
              </td>
              <td>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                  className="input-employee"
                />
              </td>
              <td style={{ color: "#28A745" }}>
                <select
                  className="dropdown-employee"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  required
                >
                  <option
                    className="dropdown-employee"
                    style={{ color: "grey" }}
                    value=""
                  >
                    Please Select*
                  </option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Gender</td>
              <td>Email</td>
              <td>Phone No.</td>
            </tr>

            <tr>
              <td>
                <select
                  className="dropdown-employee"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option
                    className="dropdown-employee"
                    style={{ color: "grey" }}
                    value=""
                    required
                  >
                    Please Select*
                  </option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                  <option value="3">Other</option>
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                  className="input-employee"
                />
                {!isEmailValid && (
                  <span style={{ color: "red" }}>Invalid email address</span>
                )}
              </td>
              <td>
                <input
                  type="text"
                  name="phoneNo"
                  value={formData.phoneNo}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                  className="input-employee"
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Department</td>
              <td>Designation</td>
              <td>Region</td>
            </tr>

            <tr>
              <td>
                <select
                  name="dept_id"
                  onChange={handleSelectChange}
                  className="dropdown-employee"
                >
                  <option value="">Select an option</option>
                  {departmentDetailResponse.map((item) => (
                    <option value={item.dept_id}>{item.department}</option>
                  ))}
                </select>
              </td>
              <td>
                <select
                  name="desg_id"
                  onChange={handleChange}
                  className="dropdown-employee"
                >
                  <option value="" style={{ width: "5rem" }}>
                    Select an option
                  </option>
                  {designationDetailResponse.map((item) => (
                    <option value={item.desg_id}>{item.designation}</option>
                  ))}
                </select>
              </td>
              <td>
                <select
                  name="region"
                  onChange={handleChange}
                  value={formData.region}
                  className="dropdown-employee"
                >
                  <option value="">Select an option</option>
                  {regionDetailResponse.map((item) => (
                    <option value={item.region_id}>{item.region_name}</option>
                  ))}
                </select>
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Allocation</td>
              <td>Personal Contact Number</td>
              <td>Personal Email ID</td>
            </tr>
            <tr>
              <td>
                <select
                  className="dropdown-employee"
                  name="alloted_region"
                  value={formData.alloted_region}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select an option</option>
                  <option value="none">None</option>
                  <option value="international">International</option>
                  <option value="domestic">Domestic</option>
                  <option value="both">Both</option>
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="personal_contact_no"
                  value={formData.personal_contact_no}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>
              <td>
                <input
                  type="text"
                  name="personal_email"
                  value={formData.personal_email}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>

            <tr className="tableHeading">
              <td>Date of Joining</td>
              <td>Date of Leaving</td>
              <td>Location</td>
            </tr>
            <tr>
              <td>
                {" "}
                <input
                  type="date"
                  name="Date_Of_Joining"
                  value={formData.Date_Of_Joining}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>

              <td>
                {" "}
                <input
                  type="date"
                  name="Date_Of_Leaving"
                  value={formData.Date_Of_Leaving}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>

              <td>
                {" "}
                <input
                  type="text"
                  name="Location"
                  value={formData.Location}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>
            </tr>

            <tr className="space">
              <td colSpan={3}></td>
            </tr>

            <tr className="tableHeading">
              <td>Employee Code</td>
              <td>Profile Pic</td>
              {/* <td>Alloted Assets</td> */}
            </tr>
            <tr>
              <td>
                {" "}
                <input
                  type="text"
                  name="emp_code"
                  value={formData.emp_code}
                  placeholder="Please Enter"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>
              <td>
                {" "}
                <input
                  type="file"
                  name="ProfilePic"
                  onChange={handleChange}
                  className="input-employee"
                />
              </td>
              {/* <td>
                <Multiselect
                  className="multiselect-change-placeholder"
                  options={allocated} // Options from the API
                  selectedValues={formData.Alloted_Asset.map((name) => ({
                    name: name, // Directly mapping names
                  }))}
                  onSelect={(selectedList) => {
                    const selectedAssetNames = selectedList.map(
                      (item) => item.name
                    ); // Mapping to asset names
                    setFormData({
                      ...formData,
                      Alloted_Asset: selectedAssetNames, // Store as an array of names
                    });
                  }}
                  onRemove={(removedList) => {
                    const remainingAssetNames = removedList.map(
                      (item) => item.name
                    ); // Mapping to asset names
                    setFormData({
                      ...formData,
                      Alloted_Asset: remainingAssetNames, // Update the state with remaining names
                    });
                  }}
                  displayValue="name" // Field to display in the dropdown
                  placeholder="Select Alloted Assets"
                />
              </td> */}
            </tr>


            <tr className="space">
              <td colSpan={3}></td>
            </tr>

            <tr className="tableHeading">
        <td>Meal Preference</td>
        <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                {" "}
                <select
                  className="dropdown-employee"
                  name="Meal_Preference"
                  value={formData.Meal_Preference}
                  onChange={handleChange}
              
                >
                  <option value="">Select an option</option>
                  <option value="Veg">Veg</option>
                  <option value="Non-Veg">Non-Veg</option>
               
                </select>
              </td>

              <td>
                {" "}
            
              </td>

              <td>
                {" "}
         
              </td>
            </tr>




          </table>
          <br />
          <hr />
          <table className="permission-table">
            <thead>
              <tr>
                <td colSpan="5" className="permission-header">
                  Please provide permission to access the module
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="permission-cell">
                  <label className="permission-label">
                    <input
                      type="checkbox"
                      name="is_sales"
                      checked={formData.is_sales}
                      onChange={handleCheckedChange}
                      className="custom-checkbox"
                    />
                    <span className="label-text">Sales</span>
                  </label>
                </td>
                <td className="permission-cell">
                  <label className="permission-label">
                    <input
                      type="checkbox"
                      name="is_operation"
                      checked={formData.is_operation}
                      onChange={handleCheckedChange}
                      className="custom-checkbox"
                    />
                    <span className="label-text">Operations</span>
                  </label>
                </td>
                <td className="permission-cell">
                  <label className="permission-label">
                    <input
                      type="checkbox"
                      name="is_account"
                      checked={formData.is_account}
                      onChange={handleCheckedChange}
                      className="custom-checkbox"
                    />
                    <span className="label-text">Accounts</span>
                  </label>
                </td>
                <td className="permission-cell">
                  <label className="permission-label">
                    <input
                      type="checkbox"
                      name="is_HR"
                      checked={formData.is_HR}
                      onChange={handleCheckedChange}
                      className="custom-checkbox"
                    />
                    <span className="label-text">HR</span>
                  </label>
                </td>
                <td className="permission-cell">
                  <label className="permission-label">
                    <input
                      type="checkbox"
                      name="is_master"
                      checked={formData.is_master}
                      onChange={handleCheckedChange}
                      className="custom-checkbox"
                    />
                    <span className="label-text">Master</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <hr />

          <div className="reset-addEmployee-button">
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Save
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default AddProfile;
